import { Component, Prop } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import VueBase from '@/VueBase';
import { locales } from '@/i18n-setup';
import helper, { _loadComponent } from '@/services/helper';
import Q from 'q';
import _ from 'lodash';
import api from '@/services/api';
import { Route, RawLocation } from 'vue-router';

@Component<ThankYouMixins>({
  computed: {
    ...mapState({
      Countdown: 'FinalCountdown',
    }),
  },
})
export default class ThankYouMixins extends VueBase {
  async mounted() {
    helper.close();
    helper.playNotification();
  }

  onCountdownStop() {
    if (process.env.VUE_APP_MODE === 'CS') {
      this.$router.push({ name: 'Start' });
    }
    if (process.env.VUE_APP_MODE === 'SA') {
      this.$router.push({ name: 'VoterAssign' });
    }
    if (process.env.VUE_APP_MODE === 'WEB') {
      this.$router.push({ name: 'Login' });
    }
  }
}
